<script lang="ts" setup name="OrganisationHomeTheLatestNews">
import BaseCardLink from '~/components/BaseCardLink.vue';
import Card from '~/components/Card.vue';
import XTitle from '~/components/XTitle.vue';

const {
  image,
  month,
  day,
  year,
  title,
  summary,
  postLink,
  hasError = false,
  loading,
} = defineProps<{
  image?: string;
  month?: string;
  day?: number;
  year?: number;
  title?: string;
  summary?: string;
  postLink?: string;
  hasError?: boolean;
  loading: boolean;
}>();
</script>

<template>
  <Card title="Latest from G2 Ocean">
    <template v-if="hasError">
      <div
        class="my-4 flex h-32 w-full items-center justify-center rounded bg-charcoal-1"
      >
        <p class="text-charcoal-6">Sorry, could not load the latest news.</p>
      </div>
    </template>
    <template v-else>
      <img
        v-if="image && !loading"
        class="h-20 w-full object-cover"
        alt="news cover image"
        width="225"
        height="86"
        :src="image"
      />
      <div v-else class="image-loading h-20 w-full"></div>
      <div class="my-4 flex items-start space-x-3">
        <div v-if="loading" class="flex w-full flex-col gap-y-2">
          <p class="text-loading h-5 w-32"></p>
          <p class="text-loading h-5 w-full"></p>
          <p class="text-loading h-5 w-full"></p>
        </div>
        <template v-else>
          <div class="rounded-3 flex flex-col items-center bg-charcoal-1 p-1">
            <span class="text-xs uppercase text-charcoal-6">
              {{ month }}
            </span>
            <span class="text-2xl font-bold text-secondary-9">
              {{ day }}
            </span>
            <span class="text-xs text-charcoal-6">{{ year }}</span>
          </div>

          <div>
            <XTitle class="truncate-3-lines">
              {{ title }}
            </XTitle>
            <p class="truncate-3-lines text-sm text-secondary-9">
              {{ summary }}
            </p>
            <a
              class="mt-1 text-sm text-primary-8"
              target="_blank"
              :href="postLink"
              >Read more</a
            >
          </div>
        </template>
      </div>
      <div class="border-t border-charcoal-2 pt-4">
        <BaseCardLink
          href="https://www.g2ocean.com/news/"
          target="_blank"
          :loading="loading"
          :disabled="loading"
        >
          All news and events
        </BaseCardLink>
      </div>
    </template>
  </Card>
</template>
